function ButtonTrigger(el) {

    var self = this;

    this.el = el;
    this.button = this.el.querySelector('.button');

    this.init = function() {

        this.el.style.cursor = 'pointer';

        this.el.onmouseenter = function() {
            self.button.classList.add('button--hover');
        }

        this.el.onmouseleave = function() {
            self.button.classList.remove('button--hover');
        }

        this.el.onclick = function() {
            self.button.click();
        }
    }
}
